import React from 'react'
import { Form } from 'semantic-ui-react'

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {function} props.onChange
 * @param {string} props.embedStyleType
 */
export default function EmbedNPSStyleForm({ onChange, className, embedStyleType }) {
  function handleChange(_, { value }) {
    onChange(value)
  }

  return (
    <Form className={className}>
      <label className="bold">Style</label>
      <Form.Group inline className="mt2">
        <Form.Checkbox
          checked={embedStyleType === 'basic'}
          onChange={handleChange}
          radio
          value="basic"
          label="Basic"
        />
        <Form.Checkbox
          checked={embedStyleType === 'colorful'}
          onChange={handleChange}
          radio
          value="colorful"
          label="Colorful"
        />
        <Form.Checkbox
          checked={embedStyleType === 'conservative'}
          onChange={handleChange}
          radio
          value="conservative"
          label="Conservative"
        />
      </Form.Group>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmbedNPSStyleForm/index.js